export default {
  baseStyle: {
    list: {
      bg: "paleGrey.500",
      boxShadow: "none",
      color: "inherit",
      minW: "none",
      py: "0",
      zIndex: 1,
      borderRadius: "none",
      borderWidth: "none",
    },
    item: {
      _focus: {
        bg: "paleGrey.500",
      },
      _active: {
        bg: "paleGrey.500",
      },
      _expanded: {
        bg: "paleGrey.500",
      },
    },
  },
}
